export default "__VITE_ASSET__D1fgWqP7__"